import React from "react";

export default function LoadingFallback() {
  const shimmer = {
    background: "linear-gradient(90deg, #f8f8f8 0%, #eaeaea 50%, #f8f8f8 100%)",
    backgroundSize: "280px 100%",
    animation: "muiShimmer 1s linear infinite",
    borderRadius: 6,
  };

  return (
    <>
      <span
        aria-busy="true"
        aria-live="polite"
        style={{
          display: "inline-grid",
          placeItems: "center",
          minHeight: 48,
          padding: 8,
          verticalAlign: "middle",
        }}
      >
        <span style={{display: "inline-block", width: "100%", maxWidth: 200}}>
          <span style={{display: "block", height: 8, marginBottom: 4, width: "75%", ...shimmer}}/>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              marginTop: 6,
              width: "100%",
            }}
          >
            <span style={{display: "inline-block", width: 12, height: 12, borderRadius: "50%", ...shimmer}}/>
            <span style={{display: "inline-block", width: 24, height: 16, borderRadius: 6, ...shimmer}}/>
          </span>
        </span>
      </span>
      <style>
        {`
          @keyframes muiShimmer {
            0% { background-position: -280px 0; }
            100% { background-position: 280px 0; }
          }
        `}
      </style>
    </>
  );
}
